import React from 'react'
import { getFormattedVenmoUsername, getVenmoLink } from '../utils/users'

export default function VenmoLink ({ profile }){
  const username =  getFormattedVenmoUsername(profile?.venmo_username)
  const username_link = getVenmoLink(profile?.venmo_username)
  
  return profile?.venmo_username ? <a href={`https://venmo.com/${username_link}?txn=pay`} rel="noopener noreferrer" target='_blank'>{username}</a> : null
}